module.exports = __webpack_public_path__ + "img/lunasa prismriver_sc2.2169be47.png";